import React, { useCallback, useState, useEffect, useMemo } from 'react';
import useApiControl from './common/useApiControl';
import {useSSEData} from './common/useSseControl';
import { clearRoomCacheAndGoTop } from './common/roomFatalError';
import useRoomPhase, {
    getServerPhaseCommandFromSseData,
    SERVER_PHASE,
} from './components/room/useRoomPhase';
import RoomUsers from './components/room/RoomUsers';
import RoundPhase from './components/room/RoundPhase';
import RoomDetail from './components/room/RoomDetail';
import RoomInformation from './components/room/RoomInformation';
import { normalizeRoomInformationMessages } from './components/room/roomInformationMessages';
import RoomPopups from './components/room/RoomPopups';
import OwnerForm from './components/forms/OwnerForm';
import EventUpdatedDialog from './components/dialogs/EventUpdatedDialog';
import SaveRoundResultDialog from './components/dialogs/SaveRoundResultDialog';
import OwnerConfirmRoundResultDialog from './components/dialogs/OwnerConfirmRoundResultDialog';
import ConfirmRoundResultDialog from './components/dialogs/ConfirmRoundResultDialog';
import ResultCorrectionDialog from './components/dialogs/ResultCorrectionDialog';
import CheckEventCheckOutDialog from './components/dialogs/CheckEventCheckOutDialog';
import OwnerCheckoutSummaryDialog from './components/dialogs/OwnerCheckoutSummaryDialog';
import OwnerRoundControls from './components/room/OwnerRoundControls';
import OwnerResultDialog from './components/dialogs/OwnerResultDialog';
import SSEErrorDialog from './components/dialogs/SSEErrorDialog';



import RoomHeader from './components/headers/RoomHeader';
import LatestInformation from './components/room/LatestInformation';



import { Tabs, Tab, Box, Button, Alert } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';


import { colors } from '@mui/material';

const POPUP_VISIBLE_MS = 4500;
const POPUP_FADE_MS = 400;
const PREPARE_RETRY_DELAY_MS = 3000;
const INFORMATION_MESSAGE_TTL_MS = 60 * 1000;
const RESULT_CONFIRMATION_METHOD_OWNER = 'owner_confirmation';
const ONE_SIDED_BETS_INVALID_MESSAGE = '片方のベットに参加が集中したため、このラウンドは不成立となりました。ベットしたルームチップを返還しました。';

const RESPONSIVE_MODE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};

const getResponsiveMode = () => (
    window.innerWidth <= 500 ? RESPONSIVE_MODE.MOBILE : RESPONSIVE_MODE.DESKTOP
);

const getInformationMessageTtlMs = (_event, _round) => INFORMATION_MESSAGE_TTL_MS;

const withInformationReceivedAt = (message) => ({
    ...message,
    receivedAt: Date.now(),
});

const pruneExpiredInformationMessages = (messages, ttlMs, now = Date.now()) => (
    messages.filter((message) => (
        typeof message?.receivedAt !== 'number' ||
        now - message.receivedAt <= ttlMs
    ))
);

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function OwnerRoom({ event, room_id }) {
    const event_id = parseInt(event.id);
    const { sseData, sseError } = useSSEData(); // SSEからのデータを取得するフック
    const [event2, setEvent] = useState(event); // 更新されたイベントの状態
    const [round, setRound] = useState(null);
    const [saveRoundResultDialogVisible, setSaveRoundResultDialogVisible] = useState(false);
    const [ownerConfirmRoundResultDialogVisible, setOwnerConfirmRoundResultDialogVisible] = useState(false);
    const [confirmRoundResultDialogVisible, setConfirmRoundResultDialogVisible] = useState(false);
    const [roundResultPendingSignal, setRoundResultPendingSignal] = useState(0);
    const [resultCorrectionDialogVisible, setResultCorrectionDialogVisible] = useState(false);
    const [checkEventCheckOutDialogVisible, setCheckEventCheckOutDialogVisible ] = useState(false);
    const [ownerCheckoutSummaryDialogVisible, setOwnerCheckoutSummaryDialogVisible] = useState(false);
    const [eventUpdatedDialogVisible, setEventUpdatedDialog ] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);
    const [masterTags, setMasterTags] = useState([]);

    const [finishableRound, setFinishableRound ] = useState(false); // タイマー連動
    
    const [dialogRound, setDialogRound] = useState(event.round);
    const [ownerResultDialogVisible, setOwnerResultDialogVisible] = useState(false);
    const [dialogDatas, setDialogDatas] = useState(false);
    const [isSseErrorDialogVisible, setIsSseErrorDialogVisible] = useState(false);
    const [finishButtonResetKey, setFinishButtonResetKey] = useState(0);
    const statusRef = React.useRef([{ message: '🎉 メッセージの配信をお待ちください。', type: 'info' }]);
    const sseRef = React.useRef([]);
    const popupTimersRef = React.useRef([]);
    const popupIdRef = React.useRef(0);
    const informationPruneTimerRef = React.useRef(null);
    const completedDialogOpenedRef = React.useRef(false);
    const completedDialogDismissedRef = React.useRef(false);
    const [infomationMessages, setInfomationMessages] = useState(statusRef.current);
    const [joinPopups, setJoinPopups] = useState([]);
    const [betPopups, setBetPopups] = useState([]);
    const [operationMessage, setOperationMessage] = useState(null);


    const [user, setUser] = useState(null);
    const [responsiveMode, setResponsiveMode] = useState(getResponsiveMode);
    const { roomDisplayPhase } = useRoomPhase({
        event: event2,
        round,
        user,
        sseData,
    });
    const isOwnerConfirmation = event2?.result_confirmation_method === RESULT_CONFIRMATION_METHOD_OWNER;

    //test
    useEffect(() => {
        console.log(saveRoundResultDialogVisible);
    }, [saveRoundResultDialogVisible]);

    




    //コンストラクタ
    useEffect(() => {
        updateUser();
        updateRound();
    }, []);

    const params1 = useMemo(() => ({
        room_id: room_id,
    }), []);

    const params2 = useMemo(function() {
        // 次ラウンド開始したらevent2が更新されてこれもインクリメント
        if (event && event2 && event.round == event2.round) {
            return {
                event_id: event?.id,
                number: event?.round
            }
        } else if (event && event2 && event.round <= event2.round) {
            return {
                event_id: event2?.id,
                number: event2?.round
            }
        }
    }, [event, event2]);

    //event
    const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
        action: '/get_eventby_room',
        params: params1,
        method: 'POST',
    });

    const updateEvent = async () => {
        try {
            const result = await executeRequest1();
            if (result?.event) {
                // get_round を新しいイベント情報を元に即座に実行
                await executeRequest2({
                    event_id: result.event.id,
                    number: result.event.round
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (data1) {
            setEvent(data1.event);
        }
    }, [data1]);

    //round
    const { data: data2, loading: loading2, executeRequest: executeRequest2 } = useApiControl({
        action: '/get_round',
        params: params2,
        method: 'POST',
    });

    const updateRound = () => {
        executeRequest2().catch((error) => {
            console.error(error);
            // setExceptionOccurred(true);
        });
    };

    useEffect(() => {
        if (data2) {
            setRound(data2);
        }
    }, [data2]);

    //user
    const { data: data3, loading: loading3, executeRequest: executeRequest3 } = useApiControl({
        action: '/get_user',
        method: 'POST',
    });

    const updateUser = () => {
        executeRequest3().catch((error) => {
            console.error(error);
            // setExceptionOccurred(true);
        });
    };

    useEffect(() => {
        if (data3) {
            setUser(data3);
        }
    }, [data3]);

    // マスタータグ取得
    const { data: data4, loading: loading4, executeRequest: executeRequest4 } = useApiControl({
        action: '/get_master_tags',
        method: 'POST',
    });
    useEffect(() => {
        const localTags = localStorage.getItem('tags');
        if (localTags) {
            try {
                const parsedTags = JSON.parse(localTags);
                setMasterTags(parsedTags);
            } catch (e) {
                console.error('ローカルストレージのtagsパースエラー', e);
                executeRequest4();
            }
        } else {
            executeRequest4();
        }
    }, []);
    
    // get my result
    const params5 = useMemo(() => ({
        event_id: event?.id,
        number: dialogRound
    }), [dialogRound]);

    const { data: data5, loading: loading5, executeRequest: executeRequest5 } = useApiControl({
        action: '/get_round_result',
        params: params5,
        method: 'POST',
    });

    const prepareSettlementParams = useMemo(() => ({
        event_id: event?.id,
    }), [event?.id]);

    const { executeRequest: prepareSettlement } = useApiControl({
        action: '/prepare_round_settlement',
        params: prepareSettlementParams,
        method: 'POST',
    });

    useEffect(() => {
        if (data5) {
            setOwnerResultDialogVisible(true);
            setDialogRound(dialogRound + 1);
            setDialogDatas({
                result : data5, // contains event_users now
                event_id : event2.id
            });
        }
    }, [data5]);

    const updateMasterTags = () => {
        localStorage.removeItem('tags');
        executeRequest4().catch((error) => {
            console.error(error);
        });
    };

    useEffect(() => {
        if (data4) {
            localStorage.setItem('tags', JSON.stringify(data4.tags));
            setMasterTags(data4.tags);
        }
    }, [data4]);

    useEffect(() => {
        // 終了時刻オーバーの場合、ラウンド更新してfinishボタンの活性制御を動かす
        if (finishableRound) {

            updateRound();
        }
    }, [finishableRound]);

    useEffect(() => {
        if (sseError) {
            setIsSseErrorDialogVisible(true);
        }
    }, [sseError]);

    useEffect(() => () => {
        popupTimersRef.current.forEach(clearTimeout);
        popupTimersRef.current = [];
        if (informationPruneTimerRef.current) {
            clearTimeout(informationPruneTimerRef.current);
            informationPruneTimerRef.current = null;
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setResponsiveMode(getResponsiveMode());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const openSaveRoundResultDialog = async (visible) => {
        if (!visible) {
            setSaveRoundResultDialogVisible(false);
            setOwnerConfirmRoundResultDialogVisible(false);
            return;
        }

        try {
            setOperationMessage(null);
            const result = await prepareSettlement();
            if (result?.status === 'invalid' && result?.reason === 'one_sided_bets') {
                setSaveRoundResultDialogVisible(false);
                setOwnerConfirmRoundResultDialogVisible(false);
                setConfirmRoundResultDialogVisible(false);
                setOperationMessage({
                    severity: 'info',
                    text: ONE_SIDED_BETS_INVALID_MESSAGE,
                });
                updateUser();
                await updateEvent();
                return;
            }
            if (isOwnerConfirmation) {
                setOwnerConfirmRoundResultDialogVisible(true);
            } else {
                setSaveRoundResultDialogVisible(true);
            }
        } catch (error) {
            if (error?.response?.status === 409) {
                setOperationMessage({
                    severity: 'info',
                    text: 'サーバーと同期しています。しばらくお待ちください。',
                });
                await wait(PREPARE_RETRY_DELAY_MS);

                try {
                    const result = await prepareSettlement();
                    if (result?.status === 'invalid' && result?.reason === 'one_sided_bets') {
                        setSaveRoundResultDialogVisible(false);
                        setOwnerConfirmRoundResultDialogVisible(false);
                        setConfirmRoundResultDialogVisible(false);
                        setOperationMessage({
                            severity: 'info',
                            text: ONE_SIDED_BETS_INVALID_MESSAGE,
                        });
                        updateUser();
                        await updateEvent();
                        return;
                    }
                    setOperationMessage(null);
                    if (isOwnerConfirmation) {
                        setOwnerConfirmRoundResultDialogVisible(true);
                    } else {
                        setSaveRoundResultDialogVisible(true);
                    }
                    return;
                } catch {
                    // 連続失敗は復旧不能な状態として既存の異常処理に合流する。
                }
            }

            clearRoomCacheAndGoTop('エラーが発生しました。トップページに戻ります。このエラーが続く場合はお手数ですが管理者までご連絡ください。');
        }
    };

    // sse チェックここから
    // system: update (event)
    useEffect(() => {
    if (sseData?.type === 'system' && sseData.action === 'resync' && sseData.target === 'event') {
        executeRequest1().catch((error) => {
        console.error(error);
        });
    }
    }, [sseData]);

    // status command
    useEffect(() => {
        const commandPhase = getServerPhaseCommandFromSseData(sseData);

        switch (commandPhase) {
            case SERVER_PHASE.LOCKED:
                updateRound();
                updateUser();
                openSaveRoundResultDialog(true);
                break;
            case SERVER_PHASE.RESULT_PENDING:
                updateRound();
                setRoundResultPendingSignal((prev) => prev + 1);
                setSaveRoundResultDialogVisible(false);
                setOwnerConfirmRoundResultDialogVisible(false);
                setConfirmRoundResultDialogVisible(true);
                break;
            case SERVER_PHASE.CONFIRMED:
                setSaveRoundResultDialogVisible(false);
                setOwnerConfirmRoundResultDialogVisible(false);
                setConfirmRoundResultDialogVisible(false);
                executeRequest5();
                updateEvent();
                break;
            case SERVER_PHASE.COMPLETED:
                setSaveRoundResultDialogVisible(false);
                setOwnerConfirmRoundResultDialogVisible(false);
                setConfirmRoundResultDialogVisible(false);
                setResultCorrectionDialogVisible(false);
                setCheckEventCheckOutDialogVisible(false);
                if (!completedDialogOpenedRef.current && !completedDialogDismissedRef.current) {
                    completedDialogOpenedRef.current = true;
                    setOwnerCheckoutSummaryDialogVisible(true);
                }
                break;
            default:
                break;
        }
    }, [sseData]);

    const informationMessageTtlMs = useMemo(
        () => getInformationMessageTtlMs(event2, round),
        [event2, round]
    );

    const refreshInformationMessages = useCallback(() => {
        sseRef.current = pruneExpiredInformationMessages(sseRef.current, informationMessageTtlMs);
        const status = statusRef.current[0];
        const sse = sseRef.current.slice(0, 4);
        setInfomationMessages([status, ...sse]);
    }, [informationMessageTtlMs]);

    const addInformationMessages = useCallback((messages) => {
        const nextMessages = (Array.isArray(messages) ? messages : [messages])
            .filter((message) => message?.message)
            .map(withInformationReceivedAt);

        if (nextMessages.length === 0) {
            return;
        }

        nextMessages.forEach((message) => {
            sseRef.current.unshift(message);
        });
        sseRef.current = sseRef.current.slice(0, 50);

        refreshInformationMessages();
    }, [refreshInformationMessages]);

    useEffect(() => {
        const nextExpiresIn = sseRef.current.reduce((minRemainingMs, message) => {
            if (typeof message?.receivedAt !== 'number') {
                return minRemainingMs;
            }

            const remainingMs = message.receivedAt + informationMessageTtlMs - Date.now();
            return Math.min(minRemainingMs, Math.max(remainingMs, 0));
        }, Infinity);

        if (!Number.isFinite(nextExpiresIn)) {
            return undefined;
        }

        if (informationPruneTimerRef.current) {
            clearTimeout(informationPruneTimerRef.current);
        }

        informationPruneTimerRef.current = setTimeout(() => {
            informationPruneTimerRef.current = null;
            refreshInformationMessages();
        }, nextExpiresIn + 50);

        return () => {
            if (informationPruneTimerRef.current) {
                clearTimeout(informationPruneTimerRef.current);
                informationPruneTimerRef.current = null;
            }
        };
    }, [infomationMessages, informationMessageTtlMs, refreshInformationMessages]);

    useEffect(() => {
        sseRef.current = [];
        refreshInformationMessages();
    }, [round?.number, refreshInformationMessages]);

    const addTimedPopups = (items, setter) => {
        if (!Array.isArray(items) || items.length === 0) {
            return;
        }

        const nextItems = items.map((item) => ({
            ...item,
            id: `${Date.now()}-${popupIdRef.current++}`,
        }));

        setter((prev) => [...nextItems, ...prev].slice(0, 20));

        const fadeTimeoutId = setTimeout(() => {
            const ids = new Set(nextItems.map((item) => item.id));
            setter((prev) => prev.map((item) => (
                ids.has(item.id) ? { ...item, exiting: true } : item
            )));
        }, POPUP_VISIBLE_MS);

        const removeTimeoutId = setTimeout(() => {
            const ids = new Set(nextItems.map((item) => item.id));
            setter((prev) => prev.filter((item) => !ids.has(item.id)));
        }, POPUP_VISIBLE_MS + POPUP_FADE_MS);

        popupTimersRef.current.push(fadeTimeoutId, removeTimeoutId);
    };

    // message: roomInformationは表示先ごとに振り分ける
    useEffect(() => {
        if (sseData?.type === 'message' && sseData.action === 'notify' && sseData.target === 'roomInformation') {
            const payload = sseData.payload || {};
            const importantMessages = normalizeRoomInformationMessages(
                payload.messages,
                responsiveMode === RESPONSIVE_MODE.MOBILE,
            )
                .filter((message) => message?.type === 'important');

            addInformationMessages(importantMessages);

            addTimedPopups(payload.joinPopups, setJoinPopups);
            addTimedPopups(payload.betPopups, setBetPopups);
        }
    }, [addInformationMessages, responsiveMode, sseData]);
    // sse チェックここまで

    const updateSaveRoundResultDialogVisible = (bool) => {
        openSaveRoundResultDialog(bool);
    };

    const updateConfirmRoundResultDialogVisible = (bool) => {
        setConfirmRoundResultDialogVisible(bool);
    };

    const updateCheckEventCheckOutDialogVisible = (bool) => {
        setCheckEventCheckOutDialogVisible(bool);
    };

    const checkEventCheckOutDialogOnClose = (bool) => {
        setCheckEventCheckOutDialogVisible(bool);

    }

    const closeOwnerCheckoutSummaryDialog = () => {
        completedDialogDismissedRef.current = true;
        setOwnerCheckoutSummaryDialogVisible(false);
    };


    const handleChange = (event, newIndex) => {
        setTabIndex(newIndex);
    };

    const renderRoomLayout = () => (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            minWidth="100%"
        >
            <SSEErrorDialog isVisible={isSseErrorDialogVisible} />
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1001,
                }}
            >
                <RoomPopups joinPopups={joinPopups} betPopups={betPopups} responsiveMode={responsiveMode} />
                <RoomInformation messages={infomationMessages} />
            </Box>
            <RoomHeader user={user}/>
            <Box sx={{ width: 'min(960px, calc(100% - 24px))', mt: 1 }}>
                <Alert severity="info" sx={{ mb: 1 }}>
                    この画面はルーム設定・補助操作用です。配信中の通常進行はオーナーコンソールの利用を推奨します。
                </Alert>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                <h3 style={{ margin: 0 }}>{event2.name}　第{event2.round}ラウンド（設定・補助操作）</h3>
                <Button
                    variant="contained"
                    size="small"
                    href={`/owner-console/${room_id}`}
                >
                    オーナーコンソールへ戻る
                </Button>
                {/* 
                旧配信ビューへのリンクは残す(要件次第で削除)
                <Button
                    variant="outlined"
                    size="small"
                    href={`/stream/${room_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    endIcon={<OpenInNewIcon fontSize="small" />}
                >
                    配信ビューを開く
                </Button> */}
            </Box>
            <RoundPhase
                event={event2}
                round={round}
                roomDisplayPhase={roomDisplayPhase}
                updateRound={updateRound}
            />
            <Box
                flex="1 0 auto"
                margin="10px"
                width="100%"
                sx={{
                    pb: 'calc(85px + env(safe-area-inset-bottom))',
                    boxSizing: 'border-box',
                }}
            >

                <OwnerRoundControls
                    event={event2}
                    round={round}
                    onStart={updateRound}
                    updateSaveRoundResultDialogVisible={updateSaveRoundResultDialogVisible}
                    updateConfirmRoundResultDialogVisible={updateConfirmRoundResultDialogVisible}
                    resetDisabledKey={finishButtonResetKey}
                    dialogVisible={checkEventCheckOutDialogVisible}
                    updateDialogVisible={updateCheckEventCheckOutDialogVisible}
                />
                {operationMessage && (
                    <Alert severity={operationMessage.severity || 'info'} sx={{ mb: 1 }}>
                        {operationMessage.text}
                    </Alert>
                )}
                <SaveRoundResultDialog
                    event={event2}
                    isVisible={saveRoundResultDialogVisible}
                    onClose={() => {
                        setSaveRoundResultDialogVisible(false);
                        setFinishButtonResetKey((prev) => prev + 1);
                    }}
                    round={round}
                    nextRoundStart={updateEvent}
                />
                <OwnerConfirmRoundResultDialog
                    isVisible={ownerConfirmRoundResultDialogVisible}
                    onClose={() => {
                        setOwnerConfirmRoundResultDialogVisible(false);
                        setFinishButtonResetKey((prev) => prev + 1);
                    }}
                    round={round}
                    onConfirmed={updateEvent}
                />
                <ConfirmRoundResultDialog
                    isVisible={confirmRoundResultDialogVisible}
                    onClose={() => {
                        setConfirmRoundResultDialogVisible(false);
                        setFinishButtonResetKey((prev) => prev + 1);
                    }}
                    round={round}
                    refreshKey={roundResultPendingSignal}
                    onEdit={() => setResultCorrectionDialogVisible(true)}
                    onConfirmed={updateEvent}
                />
                <ResultCorrectionDialog
                    isVisible={resultCorrectionDialogVisible}
                    onClose={() => {
                        setResultCorrectionDialogVisible(false);
                        setFinishButtonResetKey((prev) => prev + 1);
                    }}
                    round={round}
                    onCorrected={updateEvent}
                />
                <CheckEventCheckOutDialog
                    event={event2}
                    round={round}
                    isVisible={checkEventCheckOutDialogVisible}
                    onClose={() => setCheckEventCheckOutDialogVisible(false)}
                    masterTags={masterTags}
                />
                <OwnerCheckoutSummaryDialog
                    event={event2}
                    isVisible={ownerCheckoutSummaryDialogVisible}
                    onClose={closeOwnerCheckoutSummaryDialog}
                />
                <EventUpdatedDialog
                    isVisible={eventUpdatedDialogVisible}
                    onClose={() => setEventUpdatedDialog(false)}                    
                />
                <OwnerResultDialog
                    isVisible={ownerResultDialogVisible}
                    dialogDatas={dialogDatas}
                    onClose={() => setOwnerResultDialogVisible(false)}
                />
                
                <OwnerForm
                    event={event2}
                    round={round}
                    roomDisplayPhase={roomDisplayPhase}
                    updateRound={() => updateRound()}
                    submitAfter={() => setEventUpdatedDialog(true)}
                />
            </Box>
            {/* <Tabs
                value={tabIndex}
                onChange={handleChange}
                aria-label="simple tabs"
                variant={responsiveMode === RESPONSIVE_MODE.MOBILE ? 'scrollable' : 'standard'}
                scrollButtons={responsiveMode === RESPONSIVE_MODE.MOBILE ? 'auto' : false}
            >
                <Tab label="速報" />
                <Tab label="参加者" />
                <Tab label="チャット" />
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
                <RoomUsers user={user} event_id={event_id} max={3} />
            </TabPanel>

            <TabPanel value={tabIndex} index={1}>
                <LatestInformation/>
            </TabPanel>
            <TabPanel value={tabIndex} index={2}>チャット機能</TabPanel> */}
        </Box>
    );

    if (round && user){
        if (responsiveMode === RESPONSIVE_MODE.MOBILE) {
            return renderRoomLayout();
        }

        return renderRoomLayout();
    }
};

export default OwnerRoom;
